module.exports = __webpack_public_path__ + "static/media/green.7aed6689.jpg";